import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Attachment, Comment } from 'utils/types';
import { useParams } from 'react-router';

import c from '../utils/constants';

export default function useCreateNote(referenceId?: string) {
  const params = useParams();
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation({
    mutationFn: async (
      payload: Omit<Comment, 'id' | '_id' | 'createdAt' | 'updatedAt'> & {
        attachments?: Attachment[];
      },
    ) => {
      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: 'api/v1/comments/',
            payload,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/comments/`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries({
        queryKey: [c.NOTES, payload.referenceId],
      });

      queryClient.invalidateQueries({
        queryKey: [c.LOGS, params.id ?? referenceId],
      });

      toastSuccess('Successfully created note.');
    },
  });
}
